const webVisits = () => {
  const currentUrl = window.location.href;
  let latestPageVisits = localStorage.getItem('latest_page_visits') || null;
  latestPageVisits = latestPageVisits ? JSON.parse(latestPageVisits) : [];

  if (currentUrl.includes('/signup') || currentUrl.includes('/gotoaccount') || currentUrl === latestPageVisits.slice(-1)[0]) {
    return;
  }

  latestPageVisits.push(currentUrl);

  if (latestPageVisits.length > 10) {
    // This will take only latest 10 values and delete old ones
    latestPageVisits.shift();
  }
  localStorage.setItem('latest_page_visits', JSON.stringify(latestPageVisits));
};

export { webVisits };
